// Coordinates are local to the game screen, including rotated screen placements.
export function characterLayout(position, count, width, height) {
  if (!count) return [];
  const cardWidth = position === 'travel'
    ? Math.min(height * 0.22, width * 0.86 / count)
    : Math.min(width * 0.16, height * 0.20, Math.min(width, height) * 0.8 / Math.max(count, 3));
  return Array.from({ length: count }, (_, index) => {
    const angle = -Math.PI / 2 + index * 2 * Math.PI / count;
    return {
      x: width / 2 + (position === 'travel' ? (index - (count - 1) / 2) * cardWidth * 1.1 : count === 1 ? 0 : Math.cos(angle) * Math.min(width, height) * 0.28),
      y: height / 2 + (position === 'travel' || count === 1 ? 0 : Math.sin(angle) * Math.min(width, height) * 0.28),
      width: cardWidth,
      height: cardWidth * 1.5
    };
  });
}
